import { render, staticRenderFns } from "./GrayscaleConfig.vue?vue&type=template&id=2d689292&"
import script from "./GrayscaleConfig.vue?vue&type=script&lang=js&"
export * from "./GrayscaleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports